import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"

function RoleGuard({ allowedRoles, children }) {
    const { userInfo } = useSelector(
        (state) => state.auth
    )

    if (!userInfo) {
        return <Navigate to="/" replace />;
    }

    if (!allowedRoles.includes(userInfo.Role)) {
        return <Navigate to="/" replace />
    }

    return children;
}

export default RoleGuard